import React from 'react';
import { Sparkles } from 'lucide-react';
import { askAi } from '../../services/ai/aiPrefill';

/**
 * The assistant, offered where the problem is (18.08.2026).
 *
 * Apiboo shipped 40 AI tools reachable exactly one way: open the side panel
 * and describe, in prose, something already on screen. This is the other way
 * in — a small affordance at the moment help is obvious (a 4xx, a failed
 * test, a SQL error), carrying the context with it so the user does not have
 * to retype what the app already knows.
 *
 * It PREFILLS rather than sends. The user is spending their own API key, and
 * an inline button that bills them on a single click is one people stop
 * trusting; seeing the question first also teaches what the assistant can be
 * asked.
 */
function AskAiButton({ prompt, references = [], label = 'Explain', title, className = '' }) {
  if (!prompt) return null;
  return (
    <button
      type="button"
      className={`ask-ai-btn ${className}`.trim()}
      title={title || 'Ask the AI assistant about this'}
      data-testid="ask-ai-button"
      onClick={(e) => {
        // These sit inside clickable rows and tab headers in places; never let
        // the click also trigger whatever is underneath.
        e.stopPropagation();
        askAi({ text: prompt, references });
      }}
    >
      <Sparkles size={11} />
      {label}
    </button>
  );
}

export default AskAiButton;
